"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  LIGHT: 'light',
  DARK: 'dark'
};
exports.default = _default;
//# sourceMappingURL=ColorScheme.js.map